import * as React from "react"

import { useFormContext } from "react-hook-form"

import type { FieldPath, FieldValues } from "react-hook-form"

type FormFieldContextValue<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName
}

type FormItemContextValue = {
  id: string
}

export const FormFieldContext = React.createContext<FormFieldContextValue | undefined>(undefined)
export const FormItemContext = React.createContext<FormItemContextValue | undefined>(undefined)

export const useFormField = () => {
  const fieldContext = React.useContext(FormFieldContext)
  const itemContext = React.useContext(FormItemContext)
  const { getFieldState, formState } = useFormContext()

  if (fieldContext === undefined) {
    throw new Error("useFormField must be used within FormField")
  }
  if (itemContext === undefined) {
    throw new Error("useFormField must be used within FormItem")
  }

  const fieldState = getFieldState(fieldContext.name, formState)
  const { id } = itemContext

  return {
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState,
  }
}
